<template>
  <div>
    <div>
      <h5 v-html="(active+1) +'.'+ data[active].examcont +'（'+ data[active].scores+'分）' "></h5>
      <paixu
        v-model="data[active].examop"
        rkey="optionid"
        showtype="optioncontent"
        @re_value="data[active].examansws = $event"
        :key="data[active].examinfoid"
      ></paixu>
    </div>
    <div style="height: 100px;width: 100%" ></div>
  </div>
</template>
<script>
  import paixu from '../../common/paixu.vue';
  export default {
    components: {
      paixu
    },
    props: {
      data: {
        type: Array,
        default: () => []
      },
      active: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        radio: ''
      }
    },
    methods: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/examonline/components/pxinfo.vue